document.addEventListener('DOMContentLoaded', function() {
    const headings = document.querySelectorAll('.footer-block__heading');

    headings.forEach(function(heading) {
      heading.addEventListener('click', function() {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        content.classList.toggle('active');
      });
    });
  });